<div class="loading-container" *ngIf="loading" [class.fade-out]="!loading">
  <app-loader></app-loader>
  <h3>Loading properties...</h3>
</div>
<mat-sidenav-container class="map-container">
  <mat-sidenav #filterSidenav mode="over" position="start" class="filter-sidebar">
    <div class="filter-header">
      <button class="mirrored-filter-tab" mat-raised-button aria-label="Hide properties list" (click)="filterSidenav.toggle()">
      <span class="tab-text">
        <i class="fa-solid fa-close tab-icon"></i>&nbsp;
        Close Filters
      </span>
    </button>
    </div>
    
    <div class="filter-content" *ngIf="isBrowser">
      <app-property-filter 
        [initialFilters]="searchRequest"
        (filterChanged)="onFilterApplied($event)"
        (onCancel)="filterSidenav.close()">
      </app-property-filter>
  </div>
  </mat-sidenav>

  <mat-sidenav #sidenav mode="side" position="end" class="item-sidebar">
    <button mat-raised-button class="show-mobile filter-toggle-btn" (click)="filterSidenav.toggle()" [class.tab-open]="filterSidenav.opened">
      <span class="tab-text"><i class="fa-solid fa-filter tab-icon"></i>&nbsp;Filter</span>
    </button>

    <button class="mirrored-tab" mat-raised-button aria-label="Hide properties list" (click)="sidenav.toggle()">
      <span class="tab-text"><i class="fa-solid fa-chevron-down"></i>&nbsp;Show Map</span>
    </button>

    <div class="property-card-container">
      <div class="list-container">
        <div class="property-count">
          {{ properties.length }} properties found
        </div>
          <div class="active-filters-container" *ngIf="getActiveFilterCount() > 0">
            <div class="filter-pills-scroll">
              <ng-container *ngFor="let filter of getActiveFilters()">
                <div class="filter-pill">
                  <span class="pill-label"><strong>{{ filter.label }}:</strong> {{ filter.value }}</span>
                  <button class="remove-pill" (click)="removeFilter(filter.key)">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </ng-container>
              <button class="clear-all-link" (click)="clearAllFilters()">Clear All</button>
            </div>
          </div>
          <div *ngFor="let p of properties" class="property-list-card-container">
              <app-property-card-simple [property]="p" (likedChange)="onPropertyLiked($event)" (selectedProperty)="onSelectedProperty($event)" (click)="selectProperty(p)" [class.selected-card]="selectedProperty?.id === p.id"></app-property-card-simple>
          </div>
        </div>
    </div>
  </mat-sidenav>
  
  <mat-sidenav-content>
    <button 
      mat-raised-button 
      class="filter-toggle-btn" 
      (click)="filterSidenav.toggle()"
      [class.tab-open]="filterSidenav.opened">
      <span class="tab-text">
        <i class="fa-solid fa-filter tab-icon"></i>&nbsp;
        Filter
      </span>
    </button>

    <button 
      *ngIf="!sidenav.opened"
      class="vertical-right-tab" 
      mat-raised-button
      aria-label="Toggle properties list"
      (click)="sidenav.toggle()"
      [class.tab-open]="sidenav.opened">
      <span class="tab-text">
        <i class="fa-solid fa-chevron-down"></i>&nbsp;
        {{ sidenav.opened ? 'Hide List' : 'Show List' }}
      </span>
    </button>

    <!-- <div class="loading-container" *ngIf="loading" [class.fade-out]="!loading">
      <app-loader></app-loader>
      <h3>Loading properties...</h3>
    </div> -->

    <app-google-map-full [locations]="locations" height="100vh" width="100vw" [zoom]="12" [selectedProperty]="selectedProperty?.id" (windowClosed)="onMapWindowClosed()"></app-google-map-full>

  </mat-sidenav-content>

  
  
</mat-sidenav-container>

<router-outlet></router-outlet>